import React from 'react';
import { IScoutingEntry, ScoutingEntryHelper } from '../../../types/model/scouting/scoutingEntry';
import { IScoutingAssignment } from '../../../types/model/scouting/scoutingAssignment';
import ScoutingEntryView from './ScoutingEntryView';

interface IAssignmentObservationViewProps {

    value : IScoutingAssignment;
}

interface IAssignmentObservationViewState {

    entries : Array<IScoutingEntry>;
    isLoading : boolean;
}

export default class AssignmentObservationView extends React.PureComponent<IAssignmentObservationViewProps, IAssignmentObservationViewState> {
    private listener ?: () => void;

    constructor(props : IAssignmentObservationViewProps) {
        super(props);
        this.state = {
            isLoading: true,
            entries: [],
        };
    }

    public componentDidMount() : void {
        this.load();
    }

    private readonly load = () => {
        this.listener = ScoutingEntryHelper.observationOollection(this.props.value.id).onSnapshot((snapshot) => {
            const entries = this.state.entries.slice();

            // "added" | "removed" | "modified"
            snapshot.docChanges().forEach((f) => {
                const entry = f.doc.data();

                const index = f.newIndex;

                switch (f.type) {
                    case 'added':
                        entries.splice(index, 1, entry);
                        break;
                    case 'modified':
                        entries.splice(f.oldIndex, 1);
                        entries.splice(index, 1, entry);
                        break;
                    case 'removed':
                        entries.splice(f.oldIndex, 1);
                        break;
                }
            });

            this.setState({
                entries,
                isLoading: false,
            });
        });
    };

    public componentWillUnmount() : void {
        if (this.listener) {
            this.listener();
        }
    }

    public readonly render = () => {
        const {
            entries,
        } = this.state;

        return (
            <div className={'fdc ais flx1'}>
                {
                    entries.map((entry) => (
                        <ScoutingEntryView key={`${entry.guid}_obs_point`} value={entry} />
                    ))
                }
            </div>);
    };
}
